import type { Container } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import type { Layout } from '../populateLayouts/types/Layout';
import type { AllProps } from '../../propsMixin/props';

type LayoutWithProps = {
  root: Container;
  data?: { applyProps?: Record<string, AllProps> };
} & Record<string, Container>;

export function layoutApplyLayoutProps(): void {
  onLayoutPopulated.connect((layout: Layout) => {
    if (!(layout as LayoutWithProps)?.data?.applyProps) return;

    const layoutWithProps = layout as LayoutWithProps;

    Object.entries(layoutWithProps.data?.applyProps ?? {}).forEach(([key, props]) => {
      (layout as Record<string, Container>)?.[key]?.props?.(props);
    });
  });
}
